import { z } from "zod";

export const editDispositionSchema = z.object({
  code: z.string().nonempty("Required"),
  text: z.string().nonempty("Required"),
});
